const Search = (props) => {

    const search = (evt) => {
        const value = evt.target.value;
        props.setSearch(value);
    }

    return (
        <section id="search">
            <div id="search-wrapper">
                <div id="search-input">
                    <label htmlFor="search-input-field"></label>
                    <input type="text" name="search" onChange={search} id="search-input-field" placeholder="Search emoji or name"/>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                </div>
            </div>
        </section>
    );
}

export default Search;